import { UrlFragments } from './globalEnums'

export const urlHasFragment = (fragment: UrlFragments): boolean => {
  return window.location.hash.includes(`#${fragment}`)
}
